import React from "react";
import "bootstrap/dist/css/bootstrap.min.css";
import "./style.css";
import "./masterclass_style.css";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import ScrollToTop from './components/ScrollToTop';
import Cookie from './components/Cookie';
import { ToastContainer } from 'react-toastify';
import MasterClassAuth from "./Utils/MasterClassAuth";

import Home from "./pages/Home/Home";
//import SinglesEvents from "./pages/SinglesEvents/SinglesEvents";
import BookTickets from "./pages/BookTickets/BookTickets";
import SinglesRunClub from "./pages/SinglesRunClub/SinglesRunClub";
import AboutUs from "./pages/AboutUs/AboutUs";
import BrandPartnership from "./pages/BrandPartnership/BrandPartnership";
import Contact from "./pages/Contact/Contact";
import CheckOut from "./pages/CheckOut/CheckOut";
import OrderCompleted from "./pages/OrderCompleted/OrderCompleted";
import OrderCompletedCancel from "./pages/OrderCompletedCancel/OrderCompletedCancel";
import EventProductPage from "./pages/EventProductPage/EventProductPage";
import EventProductPageNew from "./pages/EventProductPageNew/EventProductPageNew";
import PunchesTown2026 from "./pages/PunchesTown2026/PunchesTown2026";
import SinglesWeekendGetaway from "./pages/SinglesWeekendGetaway/SinglesWeekendGetaway";
import SpeedDatingPage from "./pages/SpeedDatingPage/SpeedDatingPage";
import SingleSocialsPage from "./pages/SingleSocialsPage/SingleSocialsPage";
import WineTastingPage from "./pages/WineTastingPage/WineTastingPage";
import RelationshipCoachingWorkshopsPage from "./pages/RelationshipCoachingWorkshopsPage/RelationshipCoachingWorkshopsPage";
import PrivacyPolicy from "./pages/PrivacyPolicy/PrivacyPolicy";
import TermsConditions from "./pages/TermsConditions/TermsConditions";
import TrustSafety from "./pages/TrustSafety/TrustSafety";
// import TestPage from "./pages/TestPage/TestPage";
import DownloadApp from "./pages/DownloadApp";
import TermsConditionsMasterclass from "./pages/TermsConditionsMasterclass/TermsConditionsMasterclass";

import Blog from "./pages/Blog/Blog";
import BlogDetails from "./pages/BlogDetails/BlogDetails";
import CallMeCard from "./pages/CallMeCard/CallMeCard";
import CheckOutCall from "./pages/CheckOutCall/CheckOutCall";
import ThankYou from "./pages/ThankYou/ThankYou";

// ----- Masterclass Auth Pages -----
import Login from "./pages/Login/Login";
import SignUp from "./pages/SignUp/SignUp";
import ForgotPassword from "./pages/ForgotPassword/ForgotPassword";
import Otp from "./pages/Otp/Otp";
import Resetpassword from "./pages/Resetpassword/Resetpassword";

// ----- Masterclass App Pages -----
import Profile from "./pages/Profile/Profile";
import RelationshipCoaching from "./pages/RelationshipCoaching/RelationshipCoaching";
import CoachingVideo from "./pages/CoachingVideo/CoachingVideo";
import MasterclassVideo from "./pages/MasterclassVideo/MasterclassVideo";
import OrderCompletedNew from "./pages/OrderCompletedNew/OrderCompletedNew";
import CheckOutNew from "./pages/CheckOutNew/CheckOutNew";

function App() {
  return (
    <>
      <Router>
        <ScrollToTop />
        <Routes>
          <Route path="/" element={<Home />} />

          {/* <Route path="/test-page/" element={<TestPage />} /> */}

          {/*<Route path="/singles-events/" element={<SinglesEvents />} />*/}

          <Route path="/upcoming-events/" element={<BookTickets />} />

          <Route path="/singles-run-club/" element={<SinglesRunClub />} />

          <Route path="/about/" element={<AboutUs />} />

          <Route path="/brand-partnership/" element={<BrandPartnership />} />

          <Route path="/contact/" element={<Contact />} />

          <Route path="/check-out/" element={<CheckOut />} />

          <Route path="/order-completed/" element={<OrderCompleted />} />

          <Route path="/order-completed-cancel/:order_number" element={<OrderCompletedCancel />} />

          <Route path="/event-product/:id" element={<EventProductPage />} />

          <Route path="/punchestownfestival" element={<EventProductPageNew />} />

          <Route path="/punchestown2026" element={<PunchesTown2026 />} />

          <Route path="/singles-weekend-getaway/" element={<SinglesWeekendGetaway />} />

          <Route path="/speed-dating/" element={<SpeedDatingPage />} />

          <Route path="/singles-events/" element={<SingleSocialsPage />} />

          <Route path="/wine-tasting/" element={<WineTastingPage />} />

          <Route path="/relationship-coaching/" element={<RelationshipCoachingWorkshopsPage />} />

          <Route path="/privacy-policy/" element={<PrivacyPolicy />} />
          <Route path="/terms-of-service/" element={<TermsConditions />} />

          <Route path="/trust-safety/" element={<TrustSafety />} />

          <Route path="/download-app/" element={<DownloadApp />} />

          <Route path="/blog/" element={<Blog />} />
          <Route path="/blog-details/:id" element={<BlogDetails />} />

          <Route path="/call-me-card/" element={<CallMeCard />} />
          <Route path="/check-out-call/" element={<CheckOutCall />} />
          <Route path="/thank-you/" element={<ThankYou />} />

          {/* Masterclass */}
          <Route path="/dating-masterclass" element={<RelationshipCoaching />} />
          <Route path="/coaching-video/:id" element={<CoachingVideo />} />
          <Route path="/master-class-video/:id" element={<MasterclassVideo />} />
          <Route path="/check-out-new/" element={<CheckOutNew />} />
          <Route path="/terms-conditions/" element={<TermsConditionsMasterclass />} />

          {/* ---- Masterclass Auth Routes (before login) ---- */}
          <Route element={<MasterClassAuth isAuthRoute={true} />}>
            <Route path="/login/" element={<Login />} />
            <Route path="/signup/" element={<SignUp />} />
            <Route path="/forgot-password/" element={<ForgotPassword />} />
            <Route path="/otp/" element={<Otp />} />
            <Route path="/reset-password/" element={<Resetpassword />} />
          </Route>
          {/* ---- Masterclass App Routes (after login) ---- */}
          <Route element={<MasterClassAuth />}>
            <Route path="/profile/" element={<Profile />} />
            <Route path="/order-completed-new/" element={<OrderCompletedNew />} />
          </Route>
        </Routes>
        <Cookie />
      </Router>
      <ToastContainer />
    </>
  );
}

export default App;
